import { z } from 'zod';
import { InspectionEntityCornSchema } from '../base.js';
import { InspectionSchema } from '../entities/inspection.js';
export const ListInspectionsApiSchema = {
    params: z.object({
        entityId: InspectionEntityCornSchema,
    }),
    query: z.object({}),
    response: z.object({
        inspections: z.array(InspectionSchema),
    }),
};
export const ListInspectionsRequestSchema = ListInspectionsApiSchema.params.merge(ListInspectionsApiSchema.query);
